import React from "react";
import { Container } from "react-bootstrap";
import LogoSVG from "@assets/svgs/logo1.svg";
import styles from "./styles/MainFooter.module.css";
import clsx from "clsx";

const MainFooter = () => {
  return (
    <div className={styles.footerWrapper}>
      <Container>
        <div className={clsx("py-4 m-0", styles.contentContainer)}>
          <div className="p-0 d-flex align-items-center">
            <img src={LogoSVG} alt="logo" className={styles.logoFooter} />
            <p className="m-0">
              © 2022 <strong>Cursus</strong>. All Rights Reserved.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

/* required: display name */
MainFooter.displayName = "MainFooter";

/* required: props types */
MainFooter.propTypes = {};

/* required: default props */
MainFooter.defaultProps = {};

export { MainFooter };
